import React, { useCallback } from "react"

//* HOCs
import { withUserContext } from 'context'

//* Components
import { ButtonSimple, FormContainer, Input } from "components/common";

const ChangeEmail = (props) => {

    const onFinish = useCallback((values) => {
        return props.changeEmail(values)
    }, [])

    return (
        <FormContainer
            className="marginSmall"
            onFinish={onFinish}
            initialValues={{ old_email: props.user.email }}
        >
            <div className={'flexBoxColumn'}>
                <Input
                    label={'Email'}
                    name={'old_email'}
                    placeholder={'Current email'}
                    errorKey={'Email'}
                    disabled={true}
                />
                {/* <Input name={'email'} placeholder={'New email'} errorKey={'New email'} /> */}
            </div>
            {/* <ButtonSimple className="save-btn" submit text="Save"/> */}
        </FormContainer>
    )
}

export default withUserContext(ChangeEmail, ['changeEmail', 'user'])
